import { TITLE_GRADIENT } from "@app/theme/tokens";
import { Box, Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export interface Crumb {
  label: string;
  /** Absent on the current page. */
  to?: string;
}

export default function PageHeader({
  title,
  subtitle,
  trail,
  action,
}: {
  title: string;
  subtitle?: string;
  trail: Crumb[];
  action?: React.ReactNode;
}) {
  return (
    <Box sx={{ mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          mb: 1,
        }}
      >
        <Breadcrumbs sx={{ fontSize: 13 }}>
          {trail.map((crumb) =>
            crumb.to ? (
              <Link
                key={crumb.label}
                component={RouterLink}
                to={crumb.to}
                variant="body2"
                underline="hover"
                color="text.secondary"
              >
                {crumb.label}
              </Link>
            ) : (
              <Typography
                key={crumb.label}
                variant="body2"
                color="text.secondary"
              >
                {crumb.label}
              </Typography>
            ),
          )}
        </Breadcrumbs>

        {action}
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontWeight: 800,
          letterSpacing: "-0.01em",
          background: TITLE_GRADIENT,
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          width: "fit-content",
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          width: 56,
          height: 3,
          mt: 0.75,
          borderRadius: 3,
          background: TITLE_GRADIENT,
        }}
      />

      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}
